<app-layout>
  <app-voltar />
  <div class="headerForm">
    <div class="title">
      <app-titulo>Laudo de Higiênização</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>
  <div class="pdf">
    <pdf-viewer
      [src]="pdfBase64"
      [rotation]="0"
      [original-size]="false"
      [show-all]="true"
      [fit-to-page]="false"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      [stick-to-page]="false"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"></pdf-viewer>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
